<!-- <app-ng-dynamic-breadcrumb
  [symbol]="'>'"
  [bgColor]="'transparent'"
  [fontSize]="'15px'"
  [fontColor]="'#161c24'"
  [lastLinkColor]="'#323639'"
>
</app-ng-dynamic-breadcrumb> -->

<div class="auction-content-body position-relative">
  <div class="card auction-content-main m-0">
    <div class="m-4">
      <p *ngIf="!tableData.length" class="m-0">No data found</p>
      <table
        datatable
        [dtOptions]="dtOptions"
        id="customer-requests"
        class="row-border hover"
      >
        <thead>
          <tr>
            <th *ngFor="let thead of theads">{{ thead }}</th>
          </tr>
        </thead>
        <tbody></tbody>
      </table>
    </div>
  </div>
</div>
